"use client";

import { useCallback, useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { getCookiebotConsentState } from "@/utils/analytics/cookiebot";
import { pushSanitizedGtmPageView } from "@/utils/analytics/gtmPageContext";

const CONSENT_EVENTS = [
  "CookiebotOnLoad",
  "CookiebotOnAccept",
  "CookiebotOnConsentChanged",
] as const;

export function AnalyticsPageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString() ?? "";
  const pagePath = `${pathname || "/"}${search ? `?${search}` : ""}`;
  const latestPagePath = useRef(pagePath);

  const pushConsentedPageView = useCallback(() => {
    if (getCookiebotConsentState("analytics") !== "granted") return;
    pushSanitizedGtmPageView(window, latestPagePath.current);
  }, []);

  useEffect(() => {
    latestPagePath.current = pagePath;
    pushConsentedPageView();
  }, [pagePath, pushConsentedPageView]);

  useEffect(() => {
    CONSENT_EVENTS.forEach((eventName) => window.addEventListener(eventName, pushConsentedPageView));
    return () => {
      CONSENT_EVENTS.forEach((eventName) => window.removeEventListener(eventName, pushConsentedPageView));
    };
  }, [pushConsentedPageView]);

  return null;
}
